var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1378 10.9876C22.7152 11.565 22.7247 12.4982 22.1591 13.0872L16.7422 18.7283C16.4669 19.015 16.0891 19.1807 15.6918 19.189L13.4164 19.2367L13.4645 16.9462C13.4726 16.5579 13.6311 16.1878 13.9065 15.914L19.4436 10.4086C20.0298 9.82565 20.9773 9.827 21.5619 10.4116L22.1378 10.9876Z",
    fill: "#26875C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.6007 9.33594C16.9688 9.33594 17.2673 9.63441 17.2673 10.0026C17.2673 10.3708 16.9688 10.6693 16.6007 10.6693H12.0007C11.2643 10.6693 10.6673 11.2662 10.6673 12.0026V20.0026C10.6673 20.739 11.2643 21.3359 12.0007 21.3359H20.0007C20.737 21.3359 21.334 20.739 21.334 20.0026V16.6693C21.334 16.3011 21.6325 16.0026 22.0007 16.0026C22.3688 16.0026 22.6673 16.3011 22.6673 16.6693V20.0026C22.6673 21.4754 21.4734 22.6693 20.0007 22.6693H12.0007C10.5279 22.6693 9.33398 21.4754 9.33398 20.0026V12.0026C9.33398 10.5298 10.5279 9.33594 12.0007 9.33594H16.6007Z",
    fill: "#26875C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/EditButton.8061ab3be9883ad03f2798b64ed87089.svg";
export { ForwardRef as ReactComponent };